import { render } from "./practicePageHome.vue?vue&type=template&id=6f5b45c4"
import script from "./practicePageHome.vue?vue&type=script&lang=js"
export * from "./practicePageHome.vue?vue&type=script&lang=js"

import "./practicePageHome.vue?vue&type=style&index=0&id=6f5b45c4&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__